import { z } from 'zod';
import { USER_ROLES } from './enums.js';
export const loginSchema = z.object({
    email: z.string().min(1, 'Podaj adres e-mail').email('Nieprawidłowy adres e-mail'),
    password: z.string().min(1, 'Podaj hasło'),
});
export const refreshTokenSchema = z.object({
    refreshToken: z.string().min(1),
});
export const requestPasswordResetSchema = z.object({
    email: z.string().min(1, 'Podaj adres e-mail').email('Nieprawidłowy adres e-mail'),
});
export const resetPasswordSchema = z.object({
    token: z.string().min(1),
    password: z.string().min(10, 'Hasło musi mieć co najmniej 10 znaków'),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1, 'Podaj obecne hasło'),
    newPassword: z.string().min(10, 'Nowe hasło musi mieć co najmniej 10 znaków'),
});
export const authenticatedUserSchema = z.object({
    id: z.string(),
    email: z.string(),
    fullName: z.string(),
    role: z.enum(USER_ROLES),
});
export const authTokensSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
});
export const loginResponseSchema = authTokensSchema.extend({
    user: authenticatedUserSchema,
});
//# sourceMappingURL=auth.schema.js.map